import React from 'react';
import { assets } from '../../styles/theme';

const MoonIcon = ({ variant = 'purple', className = '', size = 'md' }) => {
  const sizes = {
    sm: 'h-6 w-6',
    md: 'h-10 w-10',
    lg: 'h-16 w-16',
    xl: 'h-24 w-24'
  };

  return (
    <img 
      src={assets.icons[variant]} 
      alt="" 
      className={`${sizes[size]} ${className}`}
    />
  );
};

export default MoonIcon;
